import { AxiosError } from 'axios';

const errors: string[] = [];
const toPathname = (fullUrl: string = ''): string => {
  const url = new URL(fullUrl);
  return url.pathname;
};
const joinStrings = (...rest: string[]): string => {
  return rest.filter(value => !!value).join('<br/>');
};

export const recordAxiosError = (error: AxiosError): void => {
  const { response, code, config } = error;
  if (response) {
    const requestData = getValidDataProperty(response.config.data);
    const traceIdString = response.headers.traceparent
      ? `Trace-id: ${requestData.requestId ?? response.headers.traceparent}`
      : undefined;
    const statusCodeString = response.status.toString() ? `Status-code: ${response.status.toString()}` : undefined;
    const pathString = toPathname(response.config.url) ? `Path: ${toPathname(response.config.url)}` : undefined;
    errors.push(joinStrings(traceIdString, statusCodeString, pathString));
  } else if (config) {
    const pathString = toPathname(config.url) ? `Path: ${toPathname(config.url)}` : undefined;
    const statusCodeString = code ? `Status-code: ${code}` : undefined;
    errors.push(joinStrings(pathString, statusCodeString));
  } else {
    errors.push(error.message);
  }
};

function getValidDataProperty(data: string | undefined): Record<string, any> {
  try {
    return JSON.parse(data);
  } catch (_) {
    return {};
  }
}
export const flushErrors = (): string => {
  return errors.splice(0, errors.length).join('');
};
